import { Entity } from '@/store/shared/entity';
import DeclareGroup from '../declaregroup/entity';
export default class Invoice extends Entity<number>{
    shippingNumber:string;//运单号
    customerName:string;//客户
    shippingMark:string;//箱唛
    shipmentDate:Date;//出运日
    senderName:string;//发货人
    senderNameEn:string;//发货人En
    senderAddress:string;//发货人地址
    deal:string;//成交方式
    startPort:string;//起运港
    shippingType:string;//运输方式
    currency:string;//币种
    receiverName:string;//收货人
    receiverAddress:string;//收货人地址

    //清单
    invoiceList: Array<DeclareGroup>;
    constructor() {
        super();
        this.invoiceList = new Array<DeclareGroup>();
    }
}